//#region src/fulfillment_method.ts
var FulfillmentMethod = /* @__PURE__ */ function(FulfillmentMethod) {
	FulfillmentMethod[FulfillmentMethod["KIOSK_TO_GO"] = 1] = "KIOSK_TO_GO";
	FulfillmentMethod[FulfillmentMethod["KIOSK_DINE_IN"] = 2] = "KIOSK_DINE_IN";
	FulfillmentMethod[FulfillmentMethod["FLASH_TO_GO"] = 3] = "FLASH_TO_GO";
	FulfillmentMethod[FulfillmentMethod["FLASH_DINE_IN"] = 4] = "FLASH_DINE_IN";
	FulfillmentMethod[FulfillmentMethod["FLASH_CURBSIDE"] = 5] = "FLASH_CURBSIDE";
	FulfillmentMethod[FulfillmentMethod["FLASH_OUTPOST"] = 6] = "FLASH_OUTPOST";
	FulfillmentMethod[FulfillmentMethod["KIOSK_OUTPOST"] = 7] = "KIOSK_OUTPOST";
	FulfillmentMethod[FulfillmentMethod["FLASH_DELIVERY"] = 8] = "FLASH_DELIVERY";
	FulfillmentMethod[FulfillmentMethod["WEB_TO_GO"] = 20] = "WEB_TO_GO";
	FulfillmentMethod[FulfillmentMethod["WEB_DINE_IN"] = 21] = "WEB_DINE_IN";
	FulfillmentMethod[FulfillmentMethod["WEB_CURBSIDE"] = 22] = "WEB_CURBSIDE";
	FulfillmentMethod[FulfillmentMethod["WEB_OUTPOST"] = 23] = "WEB_OUTPOST";
	FulfillmentMethod[FulfillmentMethod["WEB_DELIVERY"] = 24] = "WEB_DELIVERY";
	FulfillmentMethod[FulfillmentMethod["LINEBUSTER_TO_GO"] = 40] = "LINEBUSTER_TO_GO";
	FulfillmentMethod[FulfillmentMethod["LINEBUSTER_DINE_IN"] = 41] = "LINEBUSTER_DINE_IN";
	FulfillmentMethod[FulfillmentMethod["LINEBUSTER_CURBSIDE"] = 42] = "LINEBUSTER_CURBSIDE";
	FulfillmentMethod[FulfillmentMethod["DRIVE_THRU_TO_GO"] = 50] = "DRIVE_THRU_TO_GO";
	return FulfillmentMethod;
}(FulfillmentMethod || {});
//#endregion
export { FulfillmentMethod };

//# sourceMappingURL=fulfillment_method.js.map